module.exports = __webpack_public_path__ + "static/desktop/img/material-2-mobile-album.058cc12b.png";